"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25845],{

/***/ 25845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JSONAnimation": function() { return /* binding */ JSONAnimation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80621);
/* harmony import */ var react_lottie_light__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69255);
/* eslint-disable react/button-has-type */ 






var JSONAnimation = function(param) {
    var jsonFile = param.jsonFile, className = param.className;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        isStopped: false,
        isPaused: false
    }), state = ref[0], setState = ref[1];
    var animateRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var intersection = (0,react_use__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(animateRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.2
    });
    var defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: jsonFile,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (animateRef && animateRef.current) {
            if (intersection && intersection.intersectionRatio < 0.2) {
                setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                    isPaused: true
                }));
            } else {
                setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                    isPaused: false
                }));
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        intersection
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: animateRef,
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lottie_light__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            options: defaultOptions,
            isStopped: state.isStopped,
            isPaused: state.isPaused
        })
    });
};
JSONAnimation.defaultProps = {
    className: ""
};
JSONAnimation.propTypes = {
    jsonFile: prop_types__WEBPACK_IMPORTED_MODULE_6___default().instanceOf(Object).isRequired,
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};


/***/ }),

/***/ 80621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIntersection = function (ref, options) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersection);


/***/ })

}]);